var map = {
	"./price-clinics/price-clinics.scss": "./src/block/price/price-clinics/price-clinics.scss",
	"./price-group/price-group.scss": "./src/block/price/price-group/price-group.scss",
	"./price-item/price-item.scss": "./src/block/price/price-item/price-item.scss",
	"./price-page/price-page.js": "./src/block/price/price-page/price-page.js",
	"./price-page/price-page.scss": "./src/block/price/price-page/price-page.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/block/price sync recursive ^\\.\\/[^/]+\\/[^/.]+\\.(js%7Ccss%7Cscss%7Csass%7Cless)$";